import { combineReducers } from "redux";
import { AuthReducer } from "./authReducer";
import { TransactionDetailsReducer } from "./transactionDetailsReducer";
import { PaymentSummaryReducer } from "./paymentSummaryReducer";
import { TncReducer } from "./tncReducer";
import { ProfileDetailsReducer } from "./profileDetailsReducer";
import errorReducer from "./errorReducer";
import isLoadingReducer from "./isLoadingReducer";
import { OtpReducer } from "./otpReducer";
import { ConfigReducer } from "./configReducer";
import { SuccessReducer } from "./successReducer";
import { MpinReducer } from "./mpinReducer";
import { UploadDocumentReducer } from "./uploadDocumentReducer";
import { PerfiosCompleteReducer } from "./perfiosCompleteReducer";

const rootReducer = combineReducers({
    auth: AuthReducer,
    isLoading: isLoadingReducer,
    error: errorReducer,
    transactionDetails: TransactionDetailsReducer,
    paymentSummary: PaymentSummaryReducer,
    tnc: TncReducer,
    profileDetails: ProfileDetailsReducer,
    otpReducer: OtpReducer,
    config: ConfigReducer,
    success: SuccessReducer,
    mpin : MpinReducer,
    upload: UploadDocumentReducer,
    perfiosComplete: PerfiosCompleteReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
